import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { getCookie } from '../auth/handleCookie';
import { getHostname } from '../utils/getHostname';
import { jwtDecode } from 'jwt-decode';
import { getSelectedAccount } from '../redux/selectedAccountSlice';
import { useSelector } from 'react-redux';
import { validateSelectedAccount } from '../utils/tokenManagement';
import { Suspense } from 'react';
import { useGetSessionQuery } from '../api/apiSlice';

const DatahubIntegrationRoute = () => {
    const { data: session, isLoading } = useGetSessionQuery();
    const isAdmin = session?.claims?.['accounts.superuser'] === "True" || false;
    const selectedAccount = useSelector(getSelectedAccount);
    //const selectedAccountValid = validateSelectedAccount(session, selectedAccount.AccountId)
    const hasService = selectedAccount?.Services?.some(s => s.Name === 'DatahubIntegration')
    const email_verified = session?.claims?.['email_verified']
    if ( !selectedAccount?.AccountId ) return
    return (hasService || isAdmin) // && email_verified
        ? <Suspense><Outlet /></Suspense>
        : <Navigate to="/" replace />;
};

export default DatahubIntegrationRoute;